import axios from 'axios';

import { ACTIONS } from '../actions';

export const getShopInfo = (shopId) => {
  return async (dispatch) => {
    dispatch({ type: ACTIONS.GET_SHOP_INFO_START, payload: { shop: { loading: true } } });
    axios
      .get('/users/unused/shops/' + shopId)
      .then((res) => {
        const shopData = res.data.data.shop;
        dispatch({
          type: ACTIONS.GET_SHOP_INFO_SUCCESS, payload: {
            shop: {
              id: parseInt(shopId, 10),
              loading: false,
              name: shopData.first_name + ' ' + shopData.last_name,
              address: shopData.address,
              postcode: shopData.post_code,
              latitude: shopData.lat,
              longitude: shopData.lng
            },
            schedules: res.data.data.schedules,
            slots: res.data.data.slots
          }
        });
      })
      .catch((e) => {
        dispatch({
          type: ACTIONS.GET_SHOP_INFO_FAILURE,
          payload: {
            shop: {
              loading: false,
              error: 'failed to get shop'
            },
            schedules: [],
            slots: []
          },
        });
      });
  };
};

export const submitUserDetails = (user) => {
  return async (dispatch) => {
    dispatch({ type: ACTIONS.USER_DETAILS_SUBMIT, payload: user });
  };
};

export const submitBookingInfo = (booking) => {
  return async (dispatch) => {
    dispatch({ type: ACTIONS.BOOKING_DETAILS_SUBMIT, payload: booking });
  };
};

export const startLoading = () => {
  return async (dispatch) => {
    dispatch({ type: ACTIONS.SUBMIT_PURCHASE_START, payload: {} });
  };
};
export const stopLoading = () => {
  return async (dispatch) => {
    dispatch({ type: ACTIONS.SUBMIT_PURCHASE_FAILURE, payload: null });
  };
};

export const submitPurchase = (service, stripeToken, stripeElement, stripe, history) => {
  return async (dispatch) => {
    dispatch({ type: ACTIONS.SUBMIT_PURCHASE_START, payload: {} });
    axios
      .post('/account/blocket-register', {
        first_name: service.user.first_name,
        last_name: service.user.last_name,
        email: service.user.email,
        phone_number: service.user.phone_number,
        address: service.user.address,
        post_code: service.user.post_code,
        stripe_token: stripeToken,
        service_date: service.booking.date,
        slot_id: service.booking.service_slot_id,
      })
      .then((res) => {
        const intent = res.data.data.intent;
        if (intent.next_action && intent.next_action.type === 'use_stripe_sdk') {
          stripe
            .confirmCardPayment(intent.client_secret, {
              payment_method: {
                card: stripeElement,
              },
            })
            .then((res) => {
              if (res.error) {
                dispatch({
                  type: ACTIONS.SUBMIT_PURCHASE_FAILURE,
                  payload: res.error,
                });
              } else {
                dispatch({ type: ACTIONS.SUBMIT_PURCHASE_SUCCESS, payload: {} });
                history.push('/success');
              }
            });
        } else {
          dispatch({ type: ACTIONS.SUBMIT_PURCHASE_SUCCESS, payload: {} });
          history.push('/success');
        }
      })
      .catch((e) => {
        dispatch({
          type: ACTIONS.SUBMIT_PURCHASE_FAILURE,
          payload: e?.response?.data?.error?.cause,
        });
      });
  };
};

export const submitBooking = (service, history) => {
  return async (dispatch) => {
    dispatch({ type: ACTIONS.SUBMIT_PURCHASE_START, payload: {} });
    await new Promise((r) => setTimeout(r, 2000));
    // if postcode change(or if they are not unique) then we need change logic on API route also
    axios
      .post('/account/blocket-register', {
        first_name: service?.user.first_name,
        last_name: service?.user.last_name,
        email: service?.user.email,
        phone_number: service?.user.phone_number && `+46${service?.user.phone_number}`,
        address: service?.user?.address?.value ?? service?.shop?.address,
        post_code: service?.user?.address?.postcode ?? service?.shop?.postcode,
        latitude: service?.user?.address?.latitude ?? service?.shop?.latitude,
        longitude: service?.user?.address?.longitude ?? service?.shop?.longitude,
        note: service?.user?.note ? `user note: ${service?.user?.note}` : '',
        service_date: service?.booking.date,
        buddy_id: service?.shop?.id,
        shop_name: service?.shop?.name,
        slot_id: service?.booking.service_slot_id,
      })
      .then(() => {
        dispatch({ type: ACTIONS.SUBMIT_PURCHASE_SUCCESS, payload: {} });
        history.push('/success');
      })
      .catch((e) => {
        dispatch({
          type: ACTIONS.SUBMIT_PURCHASE_FAILURE,
          payload: e?.response?.data?.error?.cause || 'Something went wrong, try again',
        });
      });
  };
};

export const cancelBooking = (token) => {
  return async (dispatch) => {
    dispatch({ type: ACTIONS.CANCEL_BOOKING_START, payload: null });
    axios
      .post('/account/cancel-blocket-booking', {
        token: token,
      })
      .then((res) => {
        dispatch({ type: ACTIONS.CANCEL_BOOKING_SUCCESS, payload: null });
      })
      .catch((e) => {
        dispatch({
          type: ACTIONS.CANCEL_BOOKING_FAILURE,
          payload: e?.response?.data?.error?.cause,
        });
      });
  };
};
